import { autoinject, Aurelia, bindable } from 'aurelia-framework';
import { AppRouter, RouteConfig, NavigationInstruction } from 'aurelia-router';
import { ValidationRules, validateTrigger, ValidationControllerFactory } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation/bootstrap-form-renderer';
import { AuthService } from 'aurelia-authentication';
import { EventAggregator } from 'aurelia-event-aggregator';
import { AppEvents } from 'core/app-events';

@autoinject
export class Login {
	showErrorMessage: boolean = false;
	errorMessage: string;
	title = "Login to Traken";
	validation: any;

	@bindable
	email: null;

	@bindable
	password: null;

	passwordChanged() {
		this.resetErrorMessage();
	}

	emailChanged() {
		this.resetErrorMessage();
	}

	resetErrorMessage() {
		this.showErrorMessage = false;
		this.errorMessage = '';
	}

	constructor(
		private authService:AuthService,
		private router: AppRouter,
		validationFactory: ValidationControllerFactory,
		private eventAggregator: EventAggregator
	) {
		this.validation = validationFactory.createForCurrentScope();
		this.validation.addRenderer(new BootstrapFormRenderer());
		this.validation.validateTrigger = validateTrigger.change;
	}
	async activate(params: any, routeConfig: RouteConfig, navigationInstruction: NavigationInstruction) {
		
	}

	//publishAppEvent() {
	//	console.log("AppEvent.Click.Login");
	//	ga('send', {
	//		hitType: 'event',
	//		eventCategory: 'AppEvents',
	//		eventAction: 'Click',
	//		eventLabel: 'Login'
	//	});
	//}

	async doLogin() {
		console.log("doLogin()");
		//this.publishAppEvent();
		this.errorMessage = "";
		this.showErrorMessage = false;
		try {
			
			const response = await this.authService.login(this.email, this.password);
			console.log("success logged " + response);
			this.eventAggregator.publish(AppEvents.ToggleIsBusyVisiblity, true);
			this.navigateToHomeRoute();
		}
		catch (response) {
			var data = await response.json();
			if (data) {
				this.showErrorMessage = true;
				this.errorMessage = data.message;
			}
		}
	};
	
	navigateToHomeRoute() {
		this.router.navigate('');
	}

}

    


